import { Action, Selector, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { BaseState } from '../../../base/state/base.state';
import {
  AddMasterPlanRequest,
  Filter,
  GetLocationByIdAndEntityTypeRequest,
  Job,
  Location,
  LocationIds,
  MasterPlanFilterFields,
  MasterPlanFilterType,
  MasterPlanLocation,
  MasterPlanLocationFilter,
  PlanWithJobStateRequest,
  PrivateLocatioDetails,
  PublicLocation,
} from 'planning-portal-library/src/lib/core/domain';
import { PlanContainerLocationCount } from 'planning-portal-library/src/lib/core/domain/models/plan-container-location-count';
import {
  GetLocationsCount,
  SetPublicLocations,
  GetLocationsCountByProduct,
  IsLocationAddedToMasterPlan,
  AddMasterPlan,
  SetMasterPlanLocations,
  SetSearchParam,
  SetMasterPlanId,
  SetTabIndex,
  SetIsImportVehicleOptionsVisible,
  IsEditMode,
  IsNewPlanCreated,
  SetPlanWithJobRequest,
  IsLocationDetailShow,
  SetSelectedLocationId,
  IsLocationUpdated,
  IsLocationsReImported,
  SetLocationGroupFilters,
  SetMapConfigurations,
  SetPrivateLocationDetails,
  RemovedUntitledPlan,
  SetSelectedJob,
  IsAddEditJobShow,
  SetUnassignedLocations,
  IsEditJob,
  IsJobCreated,
  SetPlanLocations,
  SetPlanDetails,
  SetLocationsIdsBySegmentId,
  IsInjectLocationInPlan,
  GetPlanJobDetails,
  IsCreateNewPlan,
  SetMasterPlanGridRequest,
  GetFilterFields,
  GetFilterType,
  SetTimeZone,
  IsImportLocationFromCSV,
  IsAddLocationManually,
  IsCalledFromMasterPlan,
  SetTimeZones,
  IsFormTouched,
  SetWeekdays,
  IsPlansPanelCollapsed,
  IsMasterPanelCollapsed,
  EnableSourceCard,
  ViewCardSettings,
  isRouteLocationDetailshow,
  GetVehicleGroup,
  IsUnassignedLocationShow,
  LocationsCardSettings,
  SetNumberOfLocationGroups,
  GetMLSFilters,
  SelectedMasterPlanType,
  SetLocationGroupsForMap,
  LocationsImported,
  LocationsUpdated,
  ReCalculateSequence,
  RenderMap,
  RenderLocationMap,
  IsHDJobsPanelCollapsed,
  IsHDPlansPanelCollapsed,
} from './new-edit-master-plan.action';
import {
  GetLocationGroupList,
  IsMasterPlanCreated,
} from '../../state/master-plan.actions';
import { MapConfigurations } from '../../../map/model';
import { PlanContainerLocationCountByProduct } from 'planning-portal-library/src/lib/core/domain/models/plan-container-location-count-by-product';
import { PlanJobDetails } from 'planning-portal-library/src/lib/core/domain/models/plan-job-details';
import { TimeZones } from 'planning-portal-library/src/lib/core/domain/models/time-zones';
import { Weekday } from 'planning-portal-library/src/lib/core/domain/models/week-days';
import { VehicleGroupDto } from 'planning-portal-library/src/lib/core/domain/requests/vehicle-group/create-edit-vehicle-group-request';
import { LocationGroup } from 'planning-portal-library/src/lib/core/domain/models/location-group';
import { SetSelectedGroupIdForMLSImport } from '../../../mater-plans/new-edit-master-plan/state/new-edit-master-plan.action';
import { PublicLocationSequenceUpdateRequest } from 'planning-portal-library/src/lib/core/domain/models/public-location-job-sequence-update';
import { GLSLocation } from 'planning-portal-library/src/lib/core/domain/models/gls-location';
export class NewEditMasterPlansStateModel {
  planLocations: Location[] | undefined;
  isJobCreated: boolean | undefined;
  setPlanDetails: boolean | undefined;
  removedUntitledPlan: boolean | undefined;
  isHDJobsPanelCollapsed: boolean | undefined;
  privateLocationDetails: PrivateLocatioDetails | undefined;
  mapConfigurations: MapConfigurations | undefined;
  locationGroup: LocationGroup | undefined;
  isLocationsReImported: boolean | undefined;
  isLocationUpdated: boolean | undefined;
  selectedLocation: Location | undefined;
  selectedLocationId: GetLocationByIdAndEntityTypeRequest | undefined;
  isLocationDetailsShow: boolean | undefined;
  isUnassignedLocationShow: any;
  isRouteLocationDetailsShow: boolean | undefined;
  isPlansPanelCollapsed: boolean | undefined;
  isHDPlansPanelCollapsed: boolean | undefined;
  isMasterPanelCollapsed: boolean | undefined;
  isNewPlanCreated: boolean | undefined;
  isEdit: boolean | undefined;
  addMasterPlan: AddMasterPlanRequest | undefined;
  locationsCount: PlanContainerLocationCount | undefined;
  locationsCountByProduct: PlanContainerLocationCountByProduct | undefined;
  mlsPublicLocations: PublicLocation[] | undefined;
  isLocationAddedToMasterPlan: boolean | undefined;
  isMasterPlanCreated: boolean | undefined;
  getLocationGroupList: boolean | undefined;
  masterPlanLocations: MasterPlanLocation[] | undefined;
  masterPlanId: string | undefined;
  tabIndex: number | undefined;
  isImportVehicleOptionsVisible: boolean | undefined;
  selectedJob: Job | undefined;
  searchParams: string | undefined;
  isAddEditJobShow: boolean | undefined;
  isEditJob: boolean | undefined;
  unassignedLocations: Location[] | undefined;
  locationIds: LocationIds[] | undefined;
  isInjectLocationInPlan: boolean | undefined;
  planJobDetails: PlanJobDetails | undefined;
  isCreateNewPlan: boolean | undefined;
  masterPlanGridRequest: any | undefined;
  masterPlanFitlerFields: MasterPlanFilterFields[] | undefined;
  masterPlanFitlerType: MasterPlanFilterType[] | undefined;
  mlsFilters: Filter[] | undefined;
  timeZone: any | undefined;
  isImportFromCSV: boolean | undefined;
  numberOfLocationGroups: number | undefined;
  isAddLocationManually: boolean | undefined;
  isCalledFromMasterPlan: boolean | undefined;
  selectedGroupId: string | undefined;
  timeZones: TimeZones[] | undefined;
  vehicleGroups: VehicleGroupDto[] | undefined;
  isFormTouched: boolean | undefined;
  weekdays: Weekday[] | undefined;
  enableSourceCard: string | undefined;
  viewCardSettings: any;
  locationCardSettings: any;
  selectedMasterPlanType: number | undefined;
  locationGroups: LocationGroup[] | undefined;
  locationsImported: boolean | undefined;
  locationsUpdated: PublicLocationSequenceUpdateRequest[] | undefined;
  reCalculateSequence: GLSLocation[] | undefined;
  renderMap: GLSLocation[][] | undefined;
  renderLocationMap: GLSLocation[][] | undefined;
}

const defaults = {
  planLocations: undefined,
  isJobCreated: undefined,
  removedUntitledPlan: undefined,
  privateLocationDetails: undefined,
  mapConfigurations: undefined,
  locationGroup: undefined,
  isLocationsReImported: undefined,
  isLocationUpdated: undefined,
  selectedLocation: undefined,
  selectedLocationId: undefined,
  isLocationDetailsShow: false,
  isUnassignedLocationShow: false,
  isRouteLocationDetailsShow: false,
  planWithJobRequest: undefined,
  isNewPlanCreated: undefined,
  isEdit: undefined,
  selectedGroupId: undefined,
  setPlanDetails: undefined,
  addMasterPlan: undefined,
  locationsCount: undefined,
  locationsCountByProduct: undefined,
  isLocationAddedToMasterPlan: undefined,
  mlsPublicLocations: undefined,
  isMasterPlanCreated: undefined,
  getLocationGroupList: undefined,
  masterPlanLocations: undefined,
  masterPlanId: undefined,
  tabIndex: 0,
  isImportVehicleOptionsVisible: undefined,
  selectedJob: undefined,
  searchParams: undefined,
  isAddEditJobShow: undefined,
  unassignedLocations: undefined,
  isEditJob: undefined,
  locationIds: undefined,
  isInjectLocationInPlan: undefined,
  planJobDetails: undefined,
  isCreateNewPlan: undefined,
  masterPlanGridRequest: undefined,
  masterPlanFitlerFields: undefined,
  masterPlanFitlerType: undefined,
  timeZone: undefined,
  mlsFilters: undefined,
  isImportFromCSV: undefined,
  numberOfLocationGroups: undefined,
  isAddLocationManually: undefined,
  isCalledFromMasterPlan: undefined,
  timeZones: undefined,
  isFormTouched: undefined,
  weekdays: undefined,
  isMasterPanelCollapsed: false,
  isPlansPanelCollapsed: false,
  isHDPlansPanelCollapsed: false,
  isHDJobsPanelCollapsed:false,
  enableSourceCard: undefined,
  vehicleGroups: undefined,
  viewCardSettings: 'normalView',
  locationCardSettings: 'normalView',
  selectedMasterPlanType: undefined,
  locationGroups: [],
  locationsImported: false,
  locationsUpdated: [],
  reCalculateSequence: [],
  renderMap: [],
  renderLocationMap: [],
};

@State<NewEditMasterPlansStateModel>({
  name: 'newEditMasterPlans',
  defaults,
})
@Injectable()
export class NewEditMasterPlansState extends BaseState {
  constructor() {
    super();
  }

  @Action(IsEditMode)
  IsEditMode(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsEditMode
  ) {
    return ctx.setState({ ...ctx.getState(), isEdit: payload });
  }

  @Action(IsNewPlanCreated)
  IsNewPlanCreated(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsNewPlanCreated
  ) {
    return ctx.setState({ ...ctx.getState(), isNewPlanCreated: payload });
  }

  @Action(IsMasterPlanCreated)
  isMasterPlanCreated(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsMasterPlanCreated
  ) {
    return ctx.setState({ ...ctx.getState(), isMasterPlanCreated: payload });
  }
  @Action(GetLocationGroupList)
  GetLocationGroupList(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetLocationGroupList
  ) {
    return ctx.setState({ ...ctx.getState(), getLocationGroupList: payload });
  }
  @Action(GetLocationsCount)
  getLocationsCount(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetLocationsCount
  ) {
    return ctx.setState({ ...ctx.getState(), locationsCount: payload });
  }
  @Action(GetLocationsCountByProduct)
  getLocationsCountByProduct(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetLocationsCountByProduct
  ) {
    return ctx.setState({
      ...ctx.getState(),
      locationsCountByProduct: payload,
    });
  }

  @Action(SetPublicLocations)
  setPublicLocations(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetPublicLocations
  ) {
    return ctx.setState({ ...ctx.getState(), mlsPublicLocations: payload });
  }

  @Action(IsLocationAddedToMasterPlan)
  isLocationAddedToMasterPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsLocationAddedToMasterPlan
  ) {
    return ctx.setState({
      ...ctx.getState(),
      isLocationAddedToMasterPlan: payload,
    });
  }

  @Action(SetSelectedGroupIdForMLSImport)
  SetSelectedGroupIdForMLSImport(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetSelectedGroupIdForMLSImport
  ) {
    ctx.setState({ ...ctx.getState(), selectedGroupId: payload });
  }

  @Action(AddMasterPlan)
  addMasterPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: AddMasterPlan
  ) {
    ctx.setState({ ...ctx.getState(), addMasterPlan: payload });
  }

  @Action(SetPlanDetails)
  setPlanDetails(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetPlanDetails
  ) {
    ctx.setState({ ...ctx.getState(), setPlanDetails: payload });
  }

  @Action(SetMasterPlanLocations)
  getPlanLocations(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetMasterPlanLocations
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanLocations: payload });
  }

  @Action(SetMasterPlanId)
  setMasterPlanId(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetMasterPlanId
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanId: payload });
  }

  @Action(SetTimeZone)
  setTimeZone(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetTimeZone
  ) {
    ctx.setState({ ...ctx.getState(), timeZone: payload });
  }

  @Action(SetTimeZones)
  setTimeZones(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetTimeZones
  ) {
    ctx.setState({ ...ctx.getState(), timeZones: payload });
  }

  @Action(SetWeekdays)
  SetWeekdays(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetWeekdays
  ) {
    ctx.setState({ ...ctx.getState(), weekdays: payload });
  }

  @Action(SetTabIndex)
  setTabIndex(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetTabIndex
  ) {
    ctx.setState({ ...ctx.getState(), tabIndex: payload });
  }
  @Action(SetIsImportVehicleOptionsVisible)
  setIsImportVehicleOptionsVisible(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetIsImportVehicleOptionsVisible
  ) {
    ctx.setState({ ...ctx.getState(), isImportVehicleOptionsVisible: payload });
  }

  @Action(IsLocationDetailShow)
  IsLocationDetailShow(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsLocationDetailShow
  ) {
    ctx.setState({ ...ctx.getState(), isLocationDetailsShow: payload });
  }

  @Action(IsUnassignedLocationShow)
  IsUnassignedShow(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsUnassignedLocationShow
  ) {
    ctx.setState({ ...ctx.getState(), isUnassignedLocationShow: payload });
  }

  @Action(isRouteLocationDetailshow)
  isRouteLocationDetailshow(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: isRouteLocationDetailshow
  ) {
    ctx.setState({ ...ctx.getState(), isRouteLocationDetailsShow: payload });
  }

  @Action(IsPlansPanelCollapsed)
  IsPlansPanelCollapsed(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsPlansPanelCollapsed
  ) {
    ctx.setState({ ...ctx.getState(), isPlansPanelCollapsed: payload });
  }

  @Action(IsHDPlansPanelCollapsed)
  IsHDPlansPanelCollapsed(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsHDPlansPanelCollapsed
  ) {
    ctx.setState({ ...ctx.getState(), isHDPlansPanelCollapsed: payload });
  }

  @Action(IsHDJobsPanelCollapsed)
  IsHDJobsPanelCollapsed(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsHDJobsPanelCollapsed
  ) {
    ctx.setState({ ...ctx.getState(), isHDJobsPanelCollapsed: payload });
  }

  @Action(IsMasterPanelCollapsed)
  IsMasterPanelCollapsed(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsMasterPanelCollapsed
  ) {
    ctx.setState({ ...ctx.getState(), isMasterPanelCollapsed: payload });
  }

  @Action(EnableSourceCard)
  EnableSourceCard(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: EnableSourceCard
  ) {
    ctx.setState({ ...ctx.getState(), enableSourceCard: payload });
  }

  @Action(SetSelectedLocationId)
  SetSelectedLocationId(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetSelectedLocationId
  ) {
    ctx.setState({ ...ctx.getState(), selectedLocationId: payload });
  }

  @Action(IsLocationUpdated)
  IsLocationUpdated(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsLocationUpdated
  ) {
    ctx.setState({ ...ctx.getState(), isLocationUpdated: payload });
  }

  @Action(IsLocationsReImported)
  IsLocationsReImported(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsLocationsReImported
  ) {
    ctx.setState({ ...ctx.getState(), isLocationsReImported: payload });
  }

  @Action(SetLocationGroupFilters)
  SetLocationGroupFilters(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetLocationGroupFilters
  ) {
    ctx.setState({ ...ctx.getState(), locationGroup: payload });
  }

  @Action(SetMapConfigurations)
  SetMapConfigurations(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetMapConfigurations
  ) {
    ctx.setState({ ...ctx.getState(), mapConfigurations: payload });
  }

  @Action(SetPrivateLocationDetails)
  SetPrivateLocationDetails(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetPrivateLocationDetails
  ) {
    ctx.setState({ ...ctx.getState(), privateLocationDetails: payload });
  }

  @Action(RemovedUntitledPlan)
  RemovedUntitledPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: RemovedUntitledPlan
  ) {
    ctx.setState({ ...ctx.getState(), removedUntitledPlan: payload });
  }

  @Action(SetSelectedJob)
  SetSelectedJob(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetSelectedJob
  ) {
    ctx.setState({ ...ctx.getState(), selectedJob: payload });
  }

  @Action(SetSearchParam)
  SetSearchParam(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetSearchParam
  ) {
    ctx.setState({ ...ctx.getState(), searchParams: payload });
  }

  @Action(IsAddEditJobShow)
  IsAddEditJobShow(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsAddEditJobShow
  ) {
    ctx.setState({ ...ctx.getState(), isAddEditJobShow: payload });
  }

  @Action(SetUnassignedLocations)
  SetUnassignedLocations(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetUnassignedLocations
  ) {
    ctx.setState({ ...ctx.getState(), unassignedLocations: payload });
  }

  @Action(IsEditJob)
  IsEditJob(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsEditJob
  ) {
    ctx.setState({ ...ctx.getState(), isEditJob: payload });
  }

  @Action(IsJobCreated)
  IsJobCreated(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsJobCreated
  ) {
    ctx.setState({ ...ctx.getState(), isJobCreated: payload });
  }

  @Action(SetPlanLocations)
  SetPlanLocations(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetPlanLocations
  ) {
    ctx.setState({ ...ctx.getState(), planLocations: payload });
  }

  @Action(SetLocationsIdsBySegmentId)
  SetLocationsIdsBySegmentId(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetLocationsIdsBySegmentId
  ) {
    ctx.setState({ ...ctx.getState(), locationIds: payload });
  }

  @Action(IsInjectLocationInPlan)
  IsInjectLocationInPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsInjectLocationInPlan
  ) {
    ctx.setState({ ...ctx.getState(), isInjectLocationInPlan: payload });
  }

  @Action(GetPlanJobDetails)
  getPlanJobDetails(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetPlanJobDetails
  ) {
    ctx.setState({ ...ctx.getState(), planJobDetails: payload });
  }

  @Action(IsCreateNewPlan)
  IsCreateNewPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsCreateNewPlan
  ) {
    ctx.setState({ ...ctx.getState(), isCreateNewPlan: payload });
  }

  @Action(SetMasterPlanGridRequest)
  SetMasterPlanGridRequest(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetMasterPlanGridRequest
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanGridRequest: payload });
  }

  @Action(GetFilterFields)
  GetFilterFields(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetFilterFields
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanFitlerFields: payload });
  }

  @Action(GetFilterType)
  GetFilterType(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetFilterType
  ) {
    ctx.setState({ ...ctx.getState(), masterPlanFitlerType: payload });
  }

  @Action(GetMLSFilters)
  GetMLSFilters(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetMLSFilters
  ) {
    ctx.setState({ ...ctx.getState(), mlsFilters: payload });
  }

  @Action(IsAddLocationManually)
  IsAddLocationManually(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsAddLocationManually
  ) {
    ctx.setState({ ...ctx.getState(), isAddLocationManually: payload });
  }

    @Action(IsCalledFromMasterPlan)
  IsCalledFromMasterPlan(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsCalledFromMasterPlan
  ) {
    ctx.setState({ ...ctx.getState(), isCalledFromMasterPlan: payload });
  }
  @Action(IsImportLocationFromCSV)
  IsImportLocationFromCSV(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsImportLocationFromCSV
  ) {
    ctx.setState({ ...ctx.getState(), isImportFromCSV: payload });
  }

  @Action(SetNumberOfLocationGroups)
  SetNumberOfLocationGroups(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetNumberOfLocationGroups
  ) {
    ctx.setState({ ...ctx.getState(), numberOfLocationGroups: payload });
  }
  @Action(GetVehicleGroup)
  GetVehicleGroups(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: GetVehicleGroup
  ) {
    ctx.setState({ ...ctx.getState(), vehicleGroups: payload });
  }

  @Action(IsFormTouched)
  IsFormTouched(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: IsFormTouched
  ) {
    ctx.setState({ ...ctx.getState(), isFormTouched: payload });
  }

  @Action(ViewCardSettings)
  ViewCardSettings(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: ViewCardSettings
  ) {
    ctx.setState({ ...ctx.getState(), viewCardSettings: payload });
  }

  @Action(LocationsCardSettings)
  LocationCardSettings(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: LocationsCardSettings
  ) {
    ctx.setState({ ...ctx.getState(), locationCardSettings: payload });
  }

  @Selector()
  static LocationsCardSettings(state: NewEditMasterPlansStateModel) {
    return state.locationCardSettings;
  }

  @Action(SelectedMasterPlanType)
  SelectedMasterPlanType(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SelectedMasterPlanType
  ) {
    ctx.setState({ ...ctx.getState(), selectedMasterPlanType: payload });
  }

  @Action(SetLocationGroupsForMap)
  SetLocationGroupsForMap(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: SetLocationGroupsForMap
  ) {
    ctx.setState({ ...ctx.getState(), locationGroups: payload });
  }

  @Action(LocationsImported)
  LocationsImported(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: LocationsImported
  ) {
    ctx.setState({ ...ctx.getState(), locationsImported: payload });
  }

  @Action(LocationsUpdated)
  LocationsUpdated(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: LocationsUpdated
  ) {
    ctx.setState({ ...ctx.getState(), locationsUpdated: payload });
  }

  @Action(ReCalculateSequence)
  ReCalculateSequence(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: ReCalculateSequence
  ) {
    ctx.setState({ ...ctx.getState(), reCalculateSequence: payload });
  }

  @Action(RenderMap)
  RenderMap(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: RenderMap
  ) {
    ctx.setState({ ...ctx.getState(), renderMap: payload });
  }
  @Action(RenderLocationMap)
  RenderLocationMap(
    ctx: StateContext<NewEditMasterPlansStateModel>,
    { payload }: RenderLocationMap
  ) {
    ctx.setState({ ...ctx.getState(), renderLocationMap: payload });
  }

  @Selector()
  static SelectedMasterPlanType(state: NewEditMasterPlansStateModel) {
    return state.selectedMasterPlanType;
  }

  @Selector()
  static ViewCardSettings(state: NewEditMasterPlansStateModel) {
    return state.viewCardSettings;
  }

  @Selector()
  static IsFormTouched(state: NewEditMasterPlansStateModel) {
    return state.isFormTouched;
  }

  @Selector()
  static VehicleGroups(state: NewEditMasterPlansStateModel) {
    return state.vehicleGroups;
  }

  @Selector()
  static IsAddLocationManually(state: NewEditMasterPlansStateModel) {
    return state.isAddLocationManually;
  }

    @Selector()
  static IsCalledFromMasterPlan(state: NewEditMasterPlansStateModel) {
    return state.isCalledFromMasterPlan;
  }

  @Selector()
  static IsImportFromCSV(state: NewEditMasterPlansStateModel) {
    return state.isImportFromCSV;
  }

  @Selector()
  static NumberOfLocationGroups(state: NewEditMasterPlansStateModel) {
    return state.numberOfLocationGroups;
  }

  @Selector()
  static GetMLSFilters(state: NewEditMasterPlansStateModel) {
    return state.mlsFilters;
  }

  @Selector()
  static GetMasterPlanFilterType(state: NewEditMasterPlansStateModel) {
    return state.masterPlanFitlerType;
  }

  @Selector()
  static GetMasterPlanFilterFields(state: NewEditMasterPlansStateModel) {
    return state.masterPlanFitlerFields;
  }

  @Selector()
  static GetMasterPlanGridRequest(state: NewEditMasterPlansStateModel) {
    return state.masterPlanGridRequest;
  }

  @Selector()
  static IsCreateNewPlan(state: NewEditMasterPlansStateModel) {
    return state.isCreateNewPlan;
  }
  @Selector()
  static PlanJobDetails(state: NewEditMasterPlansStateModel) {
    return state.planJobDetails;
  }
  @Selector()
  static IsInjectLocationInPlan(state: NewEditMasterPlansStateModel) {
    return state.isInjectLocationInPlan;
  }
  @Selector()
  static GetLocationsIdsBySegmentId(state: NewEditMasterPlansStateModel) {
    return state.locationIds;
  }
  @Selector()
  static selectedGroupIdForMLSImportLocation(
    state: NewEditMasterPlansStateModel
  ) {
    return state.selectedGroupId;
  }
  @Selector()
  static GetPlanLocations(state: NewEditMasterPlansStateModel) {
    return state.planLocations;
  }

  @Selector()
  static IsJobCreated(state: NewEditMasterPlansStateModel) {
    return state.isJobCreated;
  }

  @Selector()
  static IsEditJob(state: NewEditMasterPlansStateModel) {
    return state.isEditJob;
  }
  @Selector()
  static GetUnassignedLocations(state: NewEditMasterPlansStateModel) {
    return state.unassignedLocations;
  }

  @Selector()
  static IsAddEditJobShow(state: NewEditMasterPlansStateModel) {
    return state.isAddEditJobShow;
  }

  @Selector()
  static IsSetPlanDetails(state: NewEditMasterPlansStateModel) {
    return state.setPlanDetails;
  }

  @Selector()
  static GetSelectedJob(state: NewEditMasterPlansStateModel) {
    return state.selectedJob;
  }

  @Selector()
  static GetSearchParams(state: NewEditMasterPlansStateModel) {
    return state.searchParams;
  }

  @Selector()
  static IsRemovedUntitledPlan(state: NewEditMasterPlansStateModel) {
    return state.removedUntitledPlan;
  }

  @Selector()
  static GetPrivateLocationDetails(state: NewEditMasterPlansStateModel) {
    return state.privateLocationDetails;
  }

  @Selector()
  static GetMapConfiguration(state: NewEditMasterPlansStateModel) {
    return state.mapConfigurations;
  }

  @Selector()
  static GetLocationGroup(state: NewEditMasterPlansStateModel) {
    return state.locationGroup;
  }

  @Selector()
  static IsLocationsReImported(state: NewEditMasterPlansStateModel) {
    return state.isLocationsReImported;
  }

  @Selector()
  static IsLocationUpdated(state: NewEditMasterPlansStateModel) {
    return state.isLocationUpdated;
  }

  @Selector()
  static SelectedLocation(state: NewEditMasterPlansStateModel) {
    return state.selectedLocation;
  }

  @Selector()
  static SelectedLocationId(state: NewEditMasterPlansStateModel) {
    return state.selectedLocationId;
  }

  @Selector()
  static IsLocationDetailShow(state: NewEditMasterPlansStateModel) {
    return state.isLocationDetailsShow;
  }

  @Selector()
  static IsUnassignedLocationShow(state: NewEditMasterPlansStateModel) {
    return state.isUnassignedLocationShow;
  }

  @Selector()
  static isRouteLocationDetailshow(state: NewEditMasterPlansStateModel) {
    return state.isRouteLocationDetailsShow;
  }

  @Selector()
  static IsPlansPanelCollapsed(state: NewEditMasterPlansStateModel) {
    return state.isPlansPanelCollapsed;
  }

  @Selector()
  static IsHDPlansPanelCollapsed(state: NewEditMasterPlansStateModel) {
    return state.isHDPlansPanelCollapsed;
  }

  @Selector()
  static IsHDJobsPanelCollapsed(state: NewEditMasterPlansStateModel) {
    return state.isHDJobsPanelCollapsed;
  }

  @Selector()
  static IsMasterPanelCollapsed(state: NewEditMasterPlansStateModel) {
    return state.isMasterPanelCollapsed;
  }
  @Selector()
  static EnableSourceCard(state: NewEditMasterPlansStateModel) {
    return state.enableSourceCard;
  }
  @Selector()
  static GetLocationGroupList(state: NewEditMasterPlansStateModel) {
    return state.getLocationGroupList;
  }
  @Selector()
  static IsNewPlanCreated(state: NewEditMasterPlansStateModel) {
    return state.isNewPlanCreated;
  }

  @Selector()
  static IsEdit(state: NewEditMasterPlansStateModel) {
    return state.isEdit;
  }

  @Selector()
  static masterPlanId(state: NewEditMasterPlansStateModel) {
    return state.masterPlanId;
  }

  @Selector()
  static timeZone(state: NewEditMasterPlansStateModel) {
    return state.timeZone;
  }

  @Selector()
  static timeZones(state: NewEditMasterPlansStateModel) {
    return state.timeZones;
  }

  @Selector()
  static MasterPlanLocations(state: NewEditMasterPlansStateModel) {
    return state.masterPlanLocations;
  }

  @Selector()
  static IsLocationAddedToMasterPlan(state: NewEditMasterPlansStateModel) {
    return state.isLocationAddedToMasterPlan;
  }

  @Selector()
  static MlsPublicLocations(state: NewEditMasterPlansStateModel) {
    return state.mlsPublicLocations;
  }

  @Selector()
  static AddMasterPlan(state: NewEditMasterPlansStateModel) {
    return state.addMasterPlan;
  }

  @Selector()
  static GetLocationsCount(state: NewEditMasterPlansStateModel) {
    return state.locationsCount;
  }
  @Selector()
  static GetLocationsCountByProduct(state: NewEditMasterPlansStateModel) {
    return state.locationsCountByProduct;
  }
  @Selector()
  static IsMasterPlanCreated(state: NewEditMasterPlansStateModel) {
    return state.isMasterPlanCreated;
  }

  @Selector()
  static TabIndex(state: NewEditMasterPlansStateModel) {
    return state.tabIndex;
  }
  @Selector()
  static IsImportVehicleOptionsVisible(state: NewEditMasterPlansStateModel) {
    return state.isImportVehicleOptionsVisible;
  }

  @Selector()
  static weekdays(state: NewEditMasterPlansStateModel) {
    return state.weekdays;
  }

  @Selector()
  static GetLocationGroupsForMap(state: NewEditMasterPlansStateModel) {
    return state.locationGroups;
  }

  @Selector()
  static AreLocationsImported(state: NewEditMasterPlansStateModel) {
    return state.locationsImported;
  }

  @Selector()
  static GetLocationsUpdated(state: NewEditMasterPlansStateModel) {
    return state.locationsUpdated;
  }

  @Selector()
  static ReCalculateLocations(state: NewEditMasterPlansStateModel) {
    return state.reCalculateSequence;
  }
  @Selector()
  static RenderMap(state: NewEditMasterPlansStateModel) {
    return state.renderMap;
  }
  @Selector()
  static RenderLocationMap(state: NewEditMasterPlansStateModel) {
    return state.renderLocationMap;
  }
}
